import React from 'react';
import { useField } from 'formik';
import { IFormikFieldProps } from './FormikFieldProps';
import { FormControl, FormControlProps } from 'react-bootstrap';
import { NumericSelect as NumericSelectComponent } from '../form';

export type SelectProps = IFormikFieldProps &
  FormControlProps &
  React.HTMLAttributes<HTMLSelectElement>;

export const Select: React.FC<SelectProps> = (props) => {
  const [field, { touched, error }] = useField(props as IFormikFieldProps);
  const { children, ...rest } = props;

  return (
    <FormControl
      as="select"
      isInvalid={touched && !!error}
      {...field}
      {...rest}
    >
      {children}
    </FormControl>
  );
};

export const NumericSelect: React.FC<SelectProps> = (props) => {
  const [field, { touched, error }, { setValue }] = useField(
    props as IFormikFieldProps,
  );
  const { children, ...rest } = props;

  return (
    <FormControl
      as={NumericSelectComponent}
      isInvalid={touched && !!error}
      {...field}
      onChange={setValue}
      {...rest}
    >
      {children}
    </FormControl>
  );
};
